<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">
            <el-col :span="4">
                <div class="left" :style="{ height: `${screenHeight - 70}px` }">
                    <cus-form2 ref="form-bloodGas" :columns="bloodGasColumns" :data="bloodGasData" @confirm="confirm"></cus-form2>
                    <el-divider></el-divider>
                </div>
                <div>
                    <el-button size="mini" @click="reset">重置</el-button>
                    <el-button size="mini" type="primary" @click="postBloodGasItem">保存</el-button>
                    <el-button size="mini" type="warning" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `Desltop:blood_gas_tb`) != -1" @click="tbBloodGasItem"
                        >同步</el-button
                    >
                </div>
            </el-col>
            <el-col :span="20">
                <ListView :columns="columnsList" :datalist="bloodGasDataTable" :buttons="buttons" :tableHeight="screenHeight - 50" @extrabutton-click="ExtraButtonClick"></ListView>
            </el-col>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BloodGas`,
    data() {
        return {
            title: `血气分析`,
            token: this.$route.query.token,
            bloodGasItems: [],
            bloodGasData: {},
            bloodGasDataTable: [],
            confirmtype: 0,
            permissions: [],
            buttons: [{
                label: `删除`,
                icon: ``,
                type: `danger`,
                emit: `deleteBloodGasItem`,
                permission: `default`
            }]
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.loadBloodGasItems()
    },
    mounted() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.loadPermissions()
    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`]),
        columnsList() {
            return [{
                type: `string`,
                label: ``,
                prop: `id`,
                isKey: true
            }, {
                type: `string`,
                label: `采集时间`,
                prop: `time`,
                isListable: true,
                width: 100
            }, {
                type: `select`,
                label: `采集类型`,
                isListable: true,
                prop: `capture_type`,
                width: 100,
                // options: [{ label: `静脉血`, value: 1 }, { label: `动脉血`, value: 2 }]
                options: this.sys_enums.Enum_Capture_Type || []
            }].concat(this.bloodGasItems)
        },
        bloodGasColumns() {
            return [{
                type: `datetime`,
                label: `采集时间`,
                colspan: 24,
                prop: `time`,
                default: this.$moment().format(`YYYY/MM/DD HH:mm`)
            }, {
                type: `select`,
                label: `采集类型`,
                colspan: 24,
                prop: `capture_type`,
                // options: [{ label: `静脉血`, value: 1 }, { label: `动脉血`, value: 2 }]
                options: this.sys_enums.Enum_Capture_Type || []
            }].concat(this.bloodGasItems)
        }
    },
    methods: {
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {
            })
        },
        loadBloodGasItems() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/Intraoperative/BloodGas/GetItems`)
                let req1 = this.myaxios.get(`/api/Intraoperative/BloodGas/Get`, { surgeryId: this.$route.query.surgery_id, recordType: this.$route.query.record_type })
                this.myaxios.all(req, req1).then(([items, gasData]) => {
                    this.bloodGasItems = _.map(items, (d) => {
                        return {
                            type: `string`,
                            label: (d.unit == null || d.unit == undefined || d.unit == ``) ? d.code : `${d.code}(${d.unit})`,
                            isListable: true,
                            colspan: 24,
                            prop: `${d.id}`
                        }
                    })

                    let itemsLimit = _.reduce(items, function(result, row, index) {
                        if (row) {
                            result[row.code] = {
                                lower_limit: row.lower_limit,
                                upper_limit: row.upper_limit
                            }
                        }

                        return result
                    }, {})
                    let bloodGasDataTable = []
                    gasData.forEach(element => {
                        if (element && element.details) {
                            let gasData = {}
                            let warningClass = {}
                            let re = _.reduce(element.details, function(result, value, key) {
                                result.push(`"${value.dic_blood_gas_item_id}"` + `:` + `"${value.value}"`)
                                if (itemsLimit[value.item_name] != undefined) {
                                    let ttt = parseFloat(value.value)
                                    if (ttt != `NaN`) {
                                        if (itemsLimit[value.item_name].lower_limit > ttt || itemsLimit[value.item_name].upper_limit < ttt) {
                                            warningClass[value.dic_blood_gas_item_id] = `over_limit`
                                        }
                                    }
                                }

                                return result
                            }, [])
                            re.push(`"id":${element.id}`, `"time":"${this.$moment(element.capture_date).format(`MM/DD HH:mm`)}"`,
                                `"capture_type":${element.capture_type}`,
                                `"datetime":"${this.$moment(element.capture_date).format(`YYYY/MM/DD HH:mm`)}"`)
                            let jsonstr = `{${_.join(re, `,`)}}`
                            gasData = JSON.parse(jsonstr)
                            gasData.cell_class = warningClass
                            bloodGasDataTable.push(gasData)
                        }
                    })
                    this.bloodGasDataTable = bloodGasDataTable
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        confirm(d) {
            if (!d.time) {
                this.$message.warning(`采集时间不能为空`)
                return false
            }
            // 同步
            if (this.confirmtype == 1) {
                let req = this.myaxios.post(`/api/Intraoperative/BloodGas/GetByLis?surgery_id=${this.$route.query.surgery_id}&time=${d.time}`)
                req.then(data => {
                    if (data) {
                        let t = []
                        console.log(`data`)
                        console.log(data)

                        _.map(data, (d) => {
                            if (d.type == `data`) {
                                t.push(`"${d.id}"` + `:` + `${d.value}`)
                            } else {
                                t.push(`"${d.type}"` + `:` + `${d.value}`)
                            }
                        })
                        console.log(t)
                        let bbb = JSON.parse(`{${_.join(t, `,`)}}`)
                        console.log(bbb)
                        this.bloodGasData = bbb
                    } else {
                        this.$message.warning(`没有找到合适的数据！`)
                        return false
                    }
                }).catch(e => { console.log(e) })
            } else {
                let details = _.reduce(d, function(result, value, key) {
                    if (key !== `time` && key !== `id` && key !== `datetime` && key !== `capture_type` && value !== undefined && value !== `` && key !== `cell_class` && key !== `___sequence_no`) {
                        result.push({
                            id: 0,
                            value: value,
                            dic_blood_gas_item_id: key
                        })
                    }
                    return result
                }, [])
                if (details.length === 0) {
                    this.$message.warning(`采集数据不能为空`)
                    return false
                }
                let data = {
                    'id': this.bloodGasData && this.bloodGasData.id ? this.bloodGasData.id : 0,
                    'capture_date': d.time,
                    'capture_type': d.capture_type,
                    'enum_record_type': this.$route.query.record_type,
                    'biz_surgery_info_id': this.$route.query.surgery_id,
                    'details': details
                }

                let req
                if (this.bloodGasData && this.bloodGasData.id) {
                    req = this.myaxios.put(`/api/Intraoperative/BloodGas/Put`, data)
                } else {
                    req = this.myaxios.post(`/api/Intraoperative/BloodGas/Post`, data)
                }
                req.then(data => {
                    this.sendMessage()
                    this.loadBloodGasItems()
                    this.bloodGasData = {}
                }).catch(e => { console.log(e) })
            }
        },
        postBloodGasItem() {
            this.confirmtype = 0
            this.$refs[`form-bloodGas`].confirm()
        },
        tbBloodGasItem(d) {
            this.confirmtype = 1
            this.$refs[`form-bloodGas`].confirm()
        },
        deleteBloodGasItem({ row, index }) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.delete(`/api/Intraoperative/BloodGas/Delete/${row.id}`)
                req.then(data => {
                    this.bloodGasDataTable.splice(index, 1)
                    this.bloodGasData = {}
                    this.sendMessage()
                }).catch(e => { console.log(e) })
            })
        },
        rowClick({ row }) {
            row.time = row.datetime
            this.bloodGasData = row
            console.log(row)
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        reset() {
            this.bloodGasData = {}
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: {},
                    action: `ok`
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.left {
    width: 90%;
    overflow: auto;
    /* border: 1px solid #ccc; */
}
</style>
<style >
.over_limit span {
    color: red !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/BloodGas.vue